import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgInfo(props: RootSvgProps) {
  return (
    <RootSvg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.89526 5.85254C8.40796 5.85254 8.81812 5.43555 8.81812 4.92969C8.81812 4.41016 8.40796 4 7.89526 4C7.38257 4 6.97241 4.41016 6.97241 4.92969C6.97241 5.43555 7.38257 5.85254 7.89526 5.85254ZM6.73999 11.8545H9.49487C9.79565 11.8545 10.0349 11.6357 10.0349 11.3281C10.0349 11.041 9.79565 10.8154 9.49487 10.8154H8.72925V7.58203C8.72925 7.17871 8.53101 6.91211 8.14819 6.91211H6.86304C6.55542 6.91211 6.323 7.14453 6.323 7.43164C6.323 7.73926 6.55542 7.95801 6.86304 7.95801H7.55347V10.8154H6.73999C6.43921 10.8154 6.19995 11.041 6.19995 11.3281C6.19995 11.6357 6.43921 11.8545 6.73999 11.8545Z"
        fill="#6E6E6E"
      />
      <circle cx="8" cy="8" r="7.25" stroke="#6E6E6E" strokeWidth="1.5" />
    </RootSvg>
  );
}
